export default __webpack_public_path__ + "static/media/EpochLite产品手册_2021_v2_1_fmt_pdf.1cf93bb4.pdf";